import { Component } from 'react'
import PropTypes from 'prop-types'
import { map, noop } from 'lodash'
import Pillbox from './Pillbox'

export default class PillboxMenu extends Component {
  static propTypes = {
    namespace: PropTypes.string.isRequired,
    scope: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
      })
    ),
    value: PropTypes.string, // the selected value (from options)
    onChange: PropTypes.func,
  }

  static defaultProps = {
    namespace: `pillbox-menu`,
    scope: Math.random(),
    options: [],
    value: null,
    onChange: noop,
  }

  handleClick = value => {
    const { namespace, scope, onChange } = this.props
    onChange(namespace, scope, value)
  }

  render() {
    const { namespace, scope, options, value } = this.props

    if (false) {
      console.group('---- PillboxMenu ----')
      console.log('Props', this.props)
      console.log('Value:', value)
      console.groupEnd()
    }

    if (options.length >= 2) {
      const pills = map(options, option => {
        const isActive = value === option.value
        return (
          <Pillbox
            value={option.value}
            label={option.label}
            title={option.title}
            onClick={this.handleClick}
            isActive={isActive}
            key={`pillbox-${namespace}-${scope}-${option.value}`}
          />
        )
      })
      return <div className="pillboxes">{pills}</div>
    }
    return null
  }
}
